import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "banner-wrapper" }
const _hoisted_2 = {
  key: 0,
  "data-test": "header"
}
const _hoisted_3 = { class: "banner-inner-wrapper" }
const _hoisted_4 = ["innerHTML"]

import SpeechBubble from "@/components/Common/SpeechBubble/SpeechBubble.vue";


interface Props {
  message?: string;
  imagePath?: string;
  title?: string;
  imageWidthDesktop?: string;
  imageHeightDesktop?: string;
  imageMarginLeftDesktop?: string;
  imageWidthMobile?: string;
  imageHeightMobile?: string;
  imageMarginLeftMobile?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentBanner',
  props: {
    message: {},
    imagePath: { default: null },
    title: { default: null },
    imageWidthDesktop: { default: "170px" },
    imageHeightDesktop: { default: "250px" },
    imageMarginLeftDesktop: { default: "30px" },
    imageWidthMobile: { default: "190px" },
    imageHeightMobile: { default: "300px" },
    imageMarginLeftMobile: { default: "-5px" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "0b9558b1": (_ctx.imageWidthMobile),
  "985be1c0": (_ctx.imageHeightMobile),
  "8469fa64": (_ctx.imageMarginLeftMobile),
  "7addc9ed": (_ctx.imageWidthDesktop),
  "4b903d44": (_ctx.imageHeightDesktop),
  "0f5d6370": (_ctx.imageMarginLeftDesktop)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.title)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.imagePath)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "hero-character-cropped",
            style: _normalizeStyle({ 'background-image': 'url(' + _ctx.imagePath + ')' })
          }, null, 4))
        : _createCommentVNode("", true),
      (_ctx.message)
        ? (_openBlock(), _createBlock(SpeechBubble, {
            key: 1,
            class: "banner-bubble"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _ctx.message }, null, 8, _hoisted_4)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})